import * as React from 'react';
import {serverRootUrl} from "./config";
import {makeStyles} from "@material-ui/core/styles/index";
import { BrowserRouter as Router } from "react-router-dom"
import { Link as RouterLink } from 'react-router-dom';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";

const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
    },
    sale: {
        position: 'absolute',
        cursor: 'pointer',
    },
    year: {
        position: 'absolute',
        height:15,
        width: 60,
        backgroundImage: `url(/i/assets/year.png)`,
        right: 0,
        textAlign: 'center',
        paddingTop: 4,
        fontFamily: 'Arial',
        fontWeight: '400',
        letterSpacing: '0.00938em',
        fontSize: '.7rem',
        cursor: 'pointer',
        color: '#fff'
    },
    yearMicro: {
        position: 'absolute',
        height:15,
        width: 45,
        backgroundImage: `url(/i/assets/year.png)`,
        right: 0,
        textAlign: 'center',
        paddingTop: 4,
        fontFamily: 'Arial',
        fontWeight: '400',
        letterSpacing: '0.00938em',
        fontSize: '.7rem',
        cursor: 'pointer',
        color: '#fff'
    },
    sold1: {
        fontFamily: 'Arial',
        fontWeight: '400',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        position: 'absolute',
        fontSize: '1rem',
        color: '#fff',
        left: '50%',
        top: '50%',
        marginLeft: -23,
        marginTop: -13,
        opacity: .6,
        border: '1px solid rgba(0,0,0,0)',
        borderRadius: 5,
        padding: '3px 6px',
        background: '#000',
        cursor: 'pointer',
    },
    noImageMobile: {
        height: 100,
        position: 'relative',
        color: '#000',
    },
    noImage: {
        minHeight: 100,
        position: 'relative',
        color: '#000',
    },
    noImageLabel: {
        fontFamily: 'Arial',
        fontWeight: '400',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        fontSize: '.8rem',
        left: '50%',
        paddingTop: '40%',
        textAlign: 'center',
        color: '#000',
    },
    noImageLabelMobile: {
        fontFamily: 'Arial',
        fontWeight: '400',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        fontSize: '.7rem',
        left: '50%',
        paddingTop: '40%',
        textAlign: 'center',
        color: '#000',
        minWidth: 100,
        minHeight: 70,
        background: '#eee'
    },
    cameraIcon: {
        position: 'absolute',
        fontSize: '3rem',
        top: '30%',
        left: '50%',
        marginLeft: '-23px',
        color: '#fff',
    },
    cameraIconMobile: {
        position: 'absolute',
        fontSize: '3rem',
        top: '20%',
        left: '50%',
        marginLeft: '-23px',
        color: '#fff',
        display: 'none',
    },
}));

export function ItemTile(props) {

    const classes = useStyles();
    const [loaded, setLoaded] = React.useState();

    const item = props.item;
    const isMobile = props.isMobile;
    const label = props.label;
    const preload = props.preload;

    const titleLength = 25;

    const city = item.city ? item.city.split(' ').join('-') : '';
    let title = item.title ? item.title.split(' ').join('-').split('/').join('-') : '';
    title = title.split('"').join('in');
    const alt = item.year + ' ' + item.title + ' in ' + item.city + ',' + item.state;

    const onLoad = () => {
        console.log('onLoad')
        setLoaded(true);
    };
    //if (!props.returnRoute) {
        //throw new Error('empty return route!')
    //}

    const cssVisibility = !preload ? {} : !item.image || loaded ? {} : {visibility: 'hidden'};
    const imageProgress = !preload || !item.image || loaded ? null : <CircularProgress/>;

    return <div className={classes.root}>
            {item.sold ? <div className={classes.sold1} style={cssVisibility}
                          onClick={() => {
                              props.handleClick(item, props.returnRoute)
                          }}>SOLD</div> :
                (<div className={classes.sale}  style={cssVisibility} onClick={() => {
                    props.handleClick(item, props.returnRoute)
                }}>
                    <img src={label ? label : item.off > 0 ? '/i/assets/sale.png' : '/i/assets/offer.png'} width={60}
                         alt={props.alt ? props.alt : "offer"}/></div>)}
            <div className={props.micro ? classes.yearMicro : classes.year} style={cssVisibility} onClick={() => {
                props.handleClick(item, props.returnRoute)
            }}>
                {item.year}</div>
            <Router key={item.sn}>
                <RouterLink style={{textDecoration: 'none', display: 'block'}}
                            to={item.requestCode ? `/request/${item.requestCode}`
                                : `/for-sale/${title}/location/${city}-${item.state}/${item.sn}`}
                            onClick={() => {
                                props.handleClick(item, props.returnRoute)
                            }}>
                    {imageProgress}
                    {item.image ? <img src={serverRootUrl + "/" + item.image} alt={alt}
                                       title={alt}
                                       style={{width: '100%'}}
                                       onLoad={onLoad}
                                       /> : <div className={isMobile ? classes.noImageMobile : classes.noImage}>
                        <PhotoCameraIcon
                            className={isMobile ? classes.cameraIconMobile : classes.cameraIcon}/>
                        <div className={isMobile ? classes.noImageLabelMobile : classes.noImageLabel}>
                            {item.year} {item.title}
                        </div>
                    </div>}</RouterLink>
            </Router>
    </div>;
}